export default `
<a ng-show="item.current_user_permissions.archive" title="{{getTitle()}}" href="#" ng-click="toggleArchiveStatus()" class="icon-archive archive-btn" ng-class="{active: item.state == 'archived'}"></a>
`;
